import { useMemo } from 'react'
import Refetch from '../../ui/Refetch'
import DropdownBtn from '../../ui/DropdownBtn'
import { useMasterData } from '../../../hooks/api/useMasterData'
import { useDispatch, useSelector } from 'react-redux'
import { selectIsOption, selectOptionName, selectSelectedOptionChapelName, setOpenOption, setSelectedSortOption } from '../../../features/order/orderSlice'
import OptionsList from '../../layout/OptionsList'
import { TypesStatusListFilter } from '../../../data/data-products'
import { STATUS, STATUS_CATEGORY } from '../../../constant/constant'

export default function OrderOptionsSorting() {

    const dispatch = useDispatch()
    const selectedChapelTab = useSelector(selectSelectedOptionChapelName)
    const option = useSelector(selectOptionName)
    const isOpen = useSelector(selectIsOption)
    const { status, refetchOrders } = useMasterData()
    const orderCategory = STATUS_CATEGORY.order.name.toLowerCase();
    const allStatus = STATUS.all.name.toLowerCase();
    const cancelledStatus = STATUS.cancelled.name.toLowerCase();
    const claimedStatus = STATUS.claimed.name.toLowerCase();

    const onSelect = (value: TypesStatusListFilter) => {
        const id = value.id;
        const name = value.label;
        dispatch(setSelectedSortOption({id, name}))
    }

    const statusWithAll: TypesStatusListFilter[] = useMemo( () => [
            { id: 0, label: 'All' },
            ...status
                .filter((s) => s.category?.toLowerCase() === orderCategory)
                .map((s) => ({
                    id: s.statusId,
                    label: s.status,
                })),
        ], [status, orderCategory]
    );
    
    const options = useMemo(() => {
        const isAllTab = selectedChapelTab.toLowerCase() === allStatus;

        if (!isAllTab) {
            return statusWithAll;
        }

        return statusWithAll.filter(
            ({ label }) =>
                ![cancelledStatus, claimedStatus].includes(label.toLowerCase())
        );
    }, [ selectedChapelTab, statusWithAll, allStatus, cancelledStatus, claimedStatus]);
    

    return (
        <div className='w-full flex flex-col'>
            <div className={`flex justify-between`}>
                <div className='flex justify-center items-center'>
                    <Refetch refetch={refetchOrders} size={23} btnStyle={''}/>
                </div>
                <div className='relative inline-block h-auto'>
                    <div className='w-[120px] h-auto'>
                        <DropdownBtn
                            label={option}
                            isOpen={isOpen}
                            setIsOpenStatus={() => dispatch(setOpenOption(!isOpen))}
                        />
                        {isOpen && (
                            <OptionsList
                                options={options}
                                onSelect={onSelect}
                                onHide={() => dispatch(setOpenOption(false))}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}
